export default __webpack_public_path__ + "static/media/bg-6of7.02a6a981.svg";